import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";

var SearchConfig = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(SearchConfig, _RESTDataSource);

  var _super = _createSuper(SearchConfig);

  function SearchConfig() {
    _classCallCheck(this, SearchConfig);

    return _super.apply(this, arguments);
  }

  _createClass(SearchConfig, [{
    key: "getSearchConfig",
    value: function () {
      var _getSearchConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.get(config.s3Url));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSearchConfig() {
        return _getSearchConfig.apply(this, arguments);
      }

      return getSearchConfig;
    }()
  }]);

  return SearchConfig;
}(RESTDataSource);

export default SearchConfig;